/* Component Dependencies */
var fitnessServicesTemplate = require('templates/fitnessServices.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'fitnessServices',
  template: {
    'fitnessServices': fitnessServicesTemplate
  }
});
